export const cookieName = "mc_feature_flags";

export const delimiter = ".";

export const equality = ":";
